(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { useQuery as Kr, useLazyQuery as Jr, useMutation as zr, isApolloError as qr, gql as Me } from "@apollo/client";
import { __extends as Qr } from "tslib";
import cr, { useState as I, useEffect as M, createContext as lr, useContext as ur } from "react";
import { FormField as ae, FieldWrapper as H, Badge as ke, Icon as Fe, FlexBox as k, Text as ie, List as Xe, Banner as Zr, Button as Z, Modal as Xr, ModalHead as et, ModalBody as rt, ModalFoot as tt, Tooltip as dr, Spinner as fr, FieldSwitch as nt, InputSelectionList as ot, SelectionList as at } from "@dixa/lib-shared-habla";
import { Link as it } from "react-router-dom";
import { colors as G } from "@dixa/lib-shared-tokens";
import { useInterval as st } from "react-use";
import ct from "moment";
import { HookFormText as lt } from "lib-shared-hook-form";
import { useController as ut } from "react-hook-form";
var je = "Invariant Violation", er = Object.setPrototypeOf, dt = er === void 0 ? function(r, t) {
  return r.__proto__ = t, r;
} : er, ft = (
  /** @class */
  (function(r) {
    Qr(t, r);
    function t(o) {
      o === void 0 && (o = je);
      var i = r.call(this, typeof o == "number" ? je + ": " + o + " (see https://github.com/apollographql/invariant-packages)" : o) || this;
      return i.framesToPop = 1, i.name = je, dt(i, t.prototype), i;
    }
    return t;
  })(Error)
);
function Y(r, t) {
  if (!r)
    throw new ft(t);
}
var pr = ["debug", "log", "warn", "error", "silent"], pt = pr.indexOf("log");
function ge(r) {
  return function() {
    if (pr.indexOf(r) >= pt) {
      var t = console[r] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = ge("debug"), r.log = ge("log"), r.warn = ge("warn"), r.error = ge("error");
})(Y || (Y = {}));
var hr = "3.14.0";
function Q(r) {
  try {
    return r();
  } catch {
  }
}
const rr = Q(function() {
  return globalThis;
}) || Q(function() {
  return window;
}) || Q(function() {
  return self;
}) || Q(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Q(function() {
  return Q.constructor("return this")();
});
var tr = /* @__PURE__ */ new Map();
function ht(r) {
  var t = tr.get(r) || 1;
  return tr.set(r, t + 1), "".concat(r, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function gt(r, t) {
  var o = ht("stringifyForDisplay");
  return JSON.stringify(r, function(i, l) {
    return l === void 0 ? o : l;
  }, t).split(JSON.stringify(o)).join("<undefined>");
}
function ve(r) {
  return function(t) {
    for (var o = [], i = 1; i < arguments.length; i++)
      o[i - 1] = arguments[i];
    if (typeof t == "number") {
      var l = t;
      t = vr(l), t || (t = mr(l, o), o = []);
    }
    r.apply(void 0, [t].concat(o));
  };
}
Object.assign(function(t, o) {
  for (var i = [], l = 2; l < arguments.length; l++)
    i[l - 2] = arguments[l];
  t || Y(t, vr(o, i) || mr(o, i));
}, {
  debug: ve(Y.debug),
  log: ve(Y.log),
  warn: ve(Y.warn),
  error: ve(Y.error)
});
var nr = Symbol.for("ApolloErrorMessageHandler_" + hr);
function gr(r) {
  if (typeof r == "string")
    return r;
  try {
    return gt(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function vr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return rr[nr] && rr[nr](r, t.map(gr));
}
function mr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: hr,
      message: r,
      args: t.map(gr)
    })));
}
function Ee(r) {
  return r.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
const on = (r, t) => function(o, i) {
  return Kr(o, {
    ...i,
    context: {
      operationName: Ee(o),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, an = (r, t) => function(o, i) {
  return Jr(o, {
    ...i,
    context: {
      operationName: Ee(o),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, sn = (r, t, o) => function(i, l) {
  return o.query({
    query: i,
    variables: l,
    context: {
      operationName: Ee(i),
      widgetId: r,
      widgetType: t
    }
  });
}, cn = (r, t) => function(o, i) {
  return zr(o, {
    ...i,
    context: {
      operationName: Ee(o),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
};
var me = { exports: {} }, ne = {};
var or;
function vt() {
  if (or) return ne;
  or = 1;
  var r = cr, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, l = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(C, f, x) {
    var u, m = {}, R = null, y = null;
    x !== void 0 && (R = "" + x), f.key !== void 0 && (R = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (u in f) i.call(f, u) && !p.hasOwnProperty(u) && (m[u] = f[u]);
    if (C && C.defaultProps) for (u in f = C.defaultProps, f) m[u] === void 0 && (m[u] = f[u]);
    return { $$typeof: t, type: C, key: R, ref: y, props: m, _owner: l.current };
  }
  return ne.Fragment = o, ne.jsx = E, ne.jsxs = E, ne;
}
var oe = {};
var ar;
function mt() {
  return ar || (ar = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = cr, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), p = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), C = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), A = Symbol.iterator, S = "@@iterator";
    function D(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = A && e[A] || e[S];
      return typeof n == "function" ? n : null;
    }
    var g = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(e) {
      {
        for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)
          s[c - 1] = arguments[c];
        $("error", e, s);
      }
    }
    function $(e, n, s) {
      {
        var c = g.ReactDebugCurrentFrame, v = c.getStackAddendum();
        v !== "" && (n += "%s", s = s.concat([v]));
        var b = s.map(function(h) {
          return String(h);
        });
        b.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var X = !1, ye = !1, be = !1, Ce = !1, xe = !1, se;
    se = Symbol.for("react.module.reference");
    function Re(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === p || xe || e === l || e === x || e === u || Ce || e === y || X || ye || be || typeof e == "object" && e !== null && (e.$$typeof === R || e.$$typeof === m || e.$$typeof === E || e.$$typeof === C || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === se || e.getModuleId !== void 0));
    }
    function K(e, n, s) {
      var c = e.displayName;
      if (c)
        return c;
      var v = n.displayName || n.name || "";
      return v !== "" ? s + "(" + v + ")" : s;
    }
    function ce(e) {
      return e.displayName || "Context";
    }
    function F(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case o:
          return "Portal";
        case p:
          return "Profiler";
        case l:
          return "StrictMode";
        case x:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case C:
            var n = e;
            return ce(n) + ".Consumer";
          case E:
            var s = e;
            return ce(s._context) + ".Provider";
          case f:
            return K(e, e.render, "ForwardRef");
          case m:
            var c = e.displayName || null;
            return c !== null ? c : F(e.type) || "Memo";
          case R: {
            var v = e, b = v._payload, h = v._init;
            try {
              return F(h(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, U = 0, J, le, ee, w, W, B, re;
    function ue() {
    }
    ue.__reactDisabledLog = !0;
    function _e() {
      {
        if (U === 0) {
          J = console.log, le = console.info, ee = console.warn, w = console.error, W = console.group, B = console.groupCollapsed, re = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ue,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        U++;
      }
    }
    function Cr() {
      {
        if (U--, U === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, e, {
              value: J
            }),
            info: L({}, e, {
              value: le
            }),
            warn: L({}, e, {
              value: ee
            }),
            error: L({}, e, {
              value: w
            }),
            group: L({}, e, {
              value: W
            }),
            groupCollapsed: L({}, e, {
              value: B
            }),
            groupEnd: L({}, e, {
              value: re
            })
          });
        }
        U < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = g.ReactCurrentDispatcher, Te;
    function de(e, n, s) {
      {
        if (Te === void 0)
          try {
            throw Error();
          } catch (v) {
            var c = v.stack.trim().match(/\n( *(at )?)/);
            Te = c && c[1] || "";
          }
        return `
` + Te + e;
      }
    }
    var Se = !1, fe;
    {
      var xr = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new xr();
    }
    function Le(e, n) {
      if (!e || Se)
        return "";
      {
        var s = fe.get(e);
        if (s !== void 0)
          return s;
      }
      var c;
      Se = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = Oe.current, Oe.current = null, _e();
      try {
        if (n) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (j) {
              c = j;
            }
            Reflect.construct(e, [], h);
          } else {
            try {
              h.call();
            } catch (j) {
              c = j;
            }
            e.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            c = j;
          }
          e();
        }
      } catch (j) {
        if (j && c && typeof j.stack == "string") {
          for (var d = j.stack.split(`
`), N = c.stack.split(`
`), O = d.length - 1, T = N.length - 1; O >= 1 && T >= 0 && d[O] !== N[T]; )
            T--;
          for (; O >= 1 && T >= 0; O--, T--)
            if (d[O] !== N[T]) {
              if (O !== 1 || T !== 1)
                do
                  if (O--, T--, T < 0 || d[O] !== N[T]) {
                    var P = `
` + d[O].replace(" at new ", " at ");
                    return e.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", e.displayName)), typeof e == "function" && fe.set(e, P), P;
                  }
                while (O >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        Se = !1, Oe.current = b, Cr(), Error.prepareStackTrace = v;
      }
      var q = e ? e.displayName || e.name : "", V = q ? de(q) : "";
      return typeof e == "function" && fe.set(e, V), V;
    }
    function Rr(e, n, s) {
      return Le(e, !1);
    }
    function _r(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function pe(e, n, s) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Le(e, _r(e));
      if (typeof e == "string")
        return de(e);
      switch (e) {
        case x:
          return de("Suspense");
        case u:
          return de("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Rr(e.render);
          case m:
            return pe(e.type, n, s);
          case R: {
            var c = e, v = c._payload, b = c._init;
            try {
              return pe(b(v), n, s);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, We = {}, $e = g.ReactDebugCurrentFrame;
    function he(e) {
      if (e) {
        var n = e._owner, s = pe(e.type, e._source, n ? n.type : null);
        $e.setExtraStackFrame(s);
      } else
        $e.setExtraStackFrame(null);
    }
    function Or(e, n, s, c, v) {
      {
        var b = Function.call.bind(te);
        for (var h in e)
          if (b(e, h)) {
            var d = void 0;
            try {
              if (typeof e[h] != "function") {
                var N = Error((c || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw N.name = "Invariant Violation", N;
              }
              d = e[h](n, h, c, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              d = O;
            }
            d && !(d instanceof Error) && (he(v), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", s, h, typeof d), he(null)), d instanceof Error && !(d.message in We) && (We[d.message] = !0, he(v), _("Failed %s type: %s", s, d.message), he(null));
          }
      }
    }
    var Tr = Array.isArray;
    function we(e) {
      return Tr(e);
    }
    function Sr(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, s = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s;
      }
    }
    function wr(e) {
      try {
        return Ue(e), !1;
      } catch {
        return !0;
      }
    }
    function Ue(e) {
      return "" + e;
    }
    function Be(e) {
      if (wr(e))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Sr(e)), Ue(e);
    }
    var Ge = g.ReactCurrentOwner, Ar = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ve, Ye;
    function Dr(e) {
      if (te.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Nr(e) {
      if (te.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ir(e, n) {
      typeof e.ref == "string" && Ge.current;
    }
    function jr(e, n) {
      {
        var s = function() {
          Ve || (Ve = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Pr(e, n) {
      {
        var s = function() {
          Ye || (Ye = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var kr = function(e, n, s, c, v, b, h) {
      var d = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: s,
        props: h,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return d._store = {}, Object.defineProperty(d._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(d, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.defineProperty(d, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.freeze && (Object.freeze(d.props), Object.freeze(d)), d;
    };
    function Mr(e, n, s, c, v) {
      {
        var b, h = {}, d = null, N = null;
        s !== void 0 && (Be(s), d = "" + s), Nr(n) && (Be(n.key), d = "" + n.key), Dr(n) && (N = n.ref, Ir(n, v));
        for (b in n)
          te.call(n, b) && !Ar.hasOwnProperty(b) && (h[b] = n[b]);
        if (e && e.defaultProps) {
          var O = e.defaultProps;
          for (b in O)
            h[b] === void 0 && (h[b] = O[b]);
        }
        if (d || N) {
          var T = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          d && jr(h, T), N && Pr(h, T);
        }
        return kr(e, d, N, v, c, Ge.current, h);
      }
    }
    var Ae = g.ReactCurrentOwner, He = g.ReactDebugCurrentFrame;
    function z(e) {
      if (e) {
        var n = e._owner, s = pe(e.type, e._source, n ? n.type : null);
        He.setExtraStackFrame(s);
      } else
        He.setExtraStackFrame(null);
    }
    var De;
    De = !1;
    function Ne(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function Ke() {
      {
        if (Ae.current) {
          var e = F(Ae.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Fr(e) {
      return "";
    }
    var Je = {};
    function Lr(e) {
      {
        var n = Ke();
        if (!n) {
          var s = typeof e == "string" ? e : e.displayName || e.name;
          s && (n = `

Check the top-level render call using <` + s + ">.");
        }
        return n;
      }
    }
    function ze(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var s = Lr(n);
        if (Je[s])
          return;
        Je[s] = !0;
        var c = "";
        e && e._owner && e._owner !== Ae.current && (c = " It was passed a child from " + F(e._owner.type) + "."), z(e), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, c), z(null);
      }
    }
    function qe(e, n) {
      {
        if (typeof e != "object")
          return;
        if (we(e))
          for (var s = 0; s < e.length; s++) {
            var c = e[s];
            Ne(c) && ze(c, n);
          }
        else if (Ne(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var v = D(e);
          if (typeof v == "function" && v !== e.entries)
            for (var b = v.call(e), h; !(h = b.next()).done; )
              Ne(h.value) && ze(h.value, n);
        }
      }
    }
    function Wr(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var s;
        if (typeof n == "function")
          s = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === m))
          s = n.propTypes;
        else
          return;
        if (s) {
          var c = F(n);
          Or(s, e.props, "prop", c, e);
        } else if (n.PropTypes !== void 0 && !De) {
          De = !0;
          var v = F(n);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $r(e) {
      {
        for (var n = Object.keys(e.props), s = 0; s < n.length; s++) {
          var c = n[s];
          if (c !== "children" && c !== "key") {
            z(e), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", c), z(null);
            break;
          }
        }
        e.ref !== null && (z(e), _("Invalid attribute `ref` supplied to `React.Fragment`."), z(null));
      }
    }
    var Qe = {};
    function Ze(e, n, s, c, v, b) {
      {
        var h = Re(e);
        if (!h) {
          var d = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var N = Fr();
          N ? d += N : d += Ke();
          var O;
          e === null ? O = "null" : we(e) ? O = "array" : e !== void 0 && e.$$typeof === t ? (O = "<" + (F(e.type) || "Unknown") + " />", d = " Did you accidentally export a JSX literal instead of a component?") : O = typeof e, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, d);
        }
        var T = Mr(e, n, s, v, b);
        if (T == null)
          return T;
        if (h) {
          var P = n.children;
          if (P !== void 0)
            if (c)
              if (we(P)) {
                for (var q = 0; q < P.length; q++)
                  qe(P[q], e);
                Object.freeze && Object.freeze(P);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qe(P, e);
        }
        if (te.call(n, "key")) {
          var V = F(e), j = Object.keys(n).filter(function(Hr) {
            return Hr !== "key";
          }), Ie = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qe[V + Ie]) {
            var Yr = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ie, V, Yr, V), Qe[V + Ie] = !0;
          }
        }
        return e === i ? $r(T) : Wr(T), T;
      }
    }
    function Ur(e, n, s) {
      return Ze(e, n, s, !0);
    }
    function Br(e, n, s) {
      return Ze(e, n, s, !1);
    }
    var Gr = Br, Vr = Ur;
    oe.Fragment = i, oe.jsx = Gr, oe.jsxs = Vr;
  })()), oe;
}
var ir;
function Et() {
  return ir || (ir = 1, process.env.NODE_ENV === "production" ? me.exports = vt() : me.exports = mt()), me.exports;
}
var a = Et();
const ln = ({
  getValueByKey: r
}) => {
  const t = r("dixaApiTokenId")?.value, o = r("dixaApiTokenName")?.value;
  return /* @__PURE__ */ a.jsx(ae, { children: /* @__PURE__ */ a.jsx(H, { label: "Dixa API-Token", children: !o || !t ? /* @__PURE__ */ a.jsx(a.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ a.jsx(ke, { variant: "secondary", size: "small", children: o }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ a.jsx(it, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, yt = ({
  error: r
}) => r.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", un = ({
  errors: r
}) => r.some((t) => yt({ error: t })), bt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", dn = ({
  errors: r
}) => r.some((t) => bt({ error: t })), Ct = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", fn = ({
  errors: r
}) => r.some((t) => Ct({ error: t })), xt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", pn = ({
  errors: r
}) => r.some((t) => xt({ error: t })), Rt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", hn = ({
  errors: r
}) => r.some((t) => Rt({ error: t })), _t = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", gn = ({
  errors: r
}) => r.some((t) => _t({ error: t })), Ot = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", vn = ({
  errors: r
}) => r.some((t) => Ot({ error: t })), Tt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", mn = ({
  errors: r
}) => r.some((t) => Tt({ error: t })), St = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", En = ({
  errors: r
}) => r.some((t) => St({ error: t })), wt = ({
  error: r
}) => r.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", At = ({
  errors: r
}) => r.some((t) => wt({ error: t })), Dt = (r) => {
  const { delay: t = 2e3 } = r || {}, [o, i] = I(!1);
  return M(() => {
    const p = o ? window.setTimeout(() => i(!1), t) : void 0;
    return () => window.clearTimeout(p);
  }, [t, o]), { isCopied: o, copy: (p) => {
    navigator.clipboard.writeText(p), i(!0);
  } };
}, Nt = "_errorWrapper_171rr_1", It = "_copyIcon_171rr_5", Pe = {
  errorWrapper: Nt,
  copyIcon: It
}, jt = ({
  error: r,
  retry: t,
  isMisconfigured: o = !1
}) => {
  const l = r && qr(r) && r?.graphQLErrors?.length > 0, { isCopied: p, copy: E } = Dt(), C = /* @__PURE__ */ a.jsx(
    Fe,
    {
      color: G.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (o || l && At({
    errors: r.graphQLErrors
  }))
    return /* @__PURE__ */ a.jsxs(k, { margin: "0 0 100", padding: "200", className: Pe.errorWrapper, children: [
      /* @__PURE__ */ a.jsx(k, { margin: "0 300 0 0", alignItems: "center", children: C }),
      /* @__PURE__ */ a.jsx(ie.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!l)
    return /* @__PURE__ */ a.jsx(k, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ a.jsx(
      Xe.Item,
      {
        contentLeft: C,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const f = r?.graphQLErrors || [];
  return /* @__PURE__ */ a.jsxs(
    k,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Pe.errorWrapper,
      children: [
        f.map((x, u) => {
          const m = x?.extensions?.integration, R = m?.message || r?.message || "No error message available", y = m?.responseBody && JSON.parse(m?.responseBody), A = y?.errorMessages || [], S = y?.warningMessages || [], D = [...A, ...S].join(" ");
          return /* @__PURE__ */ a.jsx(
            Xe.Item,
            {
              title: R,
              titleSecondary: D,
              contentLeft: C
            },
            u
          );
        }),
        /* @__PURE__ */ a.jsxs(k, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ a.jsx(
            Zr,
            {
              variant: "info",
              description: /* @__PURE__ */ a.jsx(ie.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ a.jsxs(k, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ a.jsx(Z, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ a.jsx(
              Z,
              {
                variant: "secondary",
                icon: p ? "done" : "copy",
                onClick: () => E(JSON.stringify(f, null, 2)),
                className: Pe.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, Pt = ({
  headline: r,
  text: t,
  children: o,
  onConfirm: i,
  onCancel: l,
  confirmLabel: p,
  cancelLabel: E = "Cancel",
  confirmVariant: C = "primary",
  cancelVariant: f = "secondary",
  isOpen: x,
  setIsOpen: u,
  showOnClose: m = !1
}) => /* @__PURE__ */ a.jsxs(
  Xr,
  {
    isOpen: x,
    onClose: () => {
      l && l(), u(!1);
    },
    children: [
      /* @__PURE__ */ a.jsx(
        et,
        {
          title: r,
          onClose: m ? l : void 0
        }
      ),
      /* @__PURE__ */ a.jsxs(rt, { children: [
        t && /* @__PURE__ */ a.jsx("div", { style: { width: "600px" }, children: t }),
        o
      ] }),
      /* @__PURE__ */ a.jsx(
        tt,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            l && l(), u(!1);
          },
          confirmName: p,
          cancelName: E,
          confirmProps: { variant: C },
          cancelProps: { variant: f }
        }
      )
    ]
  }
);
function yn(r, t = !0) {
  try {
    return JSON.parse(JSON.stringify(r));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(r)}`), {};
  }
}
const bn = (r) => `${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()}`, kt = "DD MMM YYYY @ HH:mm";
function Cn(r) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      r.toUpperCase()
    ) ?? r;
  } catch {
    return r;
  }
}
const xn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Rn = (r) => {
  if (!r?.trim())
    return "Please add a valid subdomain";
  const o = ["https://", "http://"].find(
    (p) => r.startsWith(p)
  ), i = o ? `Please remove the protocol \`${o}\` from the hostname` : "", l = r.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && l)
    return `Please remove the protocol \`${o}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (l)
    return l;
};
function Mt(r) {
  const t = r.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const o = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(o).toString());
  } catch (i) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${i}`
    );
  }
}
function Ft(r) {
  const { user_id: t, iss: o } = Mt(r);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": o
  };
}
function Lt(r) {
  return r.startsWith("http://localhost");
}
const Wt = lr(null);
function $t() {
  const r = ur(Wt);
  if (r === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return r;
}
function _n() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function Er() {
  return { track: (t, o) => window._partner.events.emit(t, o) };
}
const Ut = (r) => {
  switch (r) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: G.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: G.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: G.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: G.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: G.neutral[500],
        tooltip: "Not connected"
      };
  }
}, On = ({
  configuration: r,
  integrationId: t,
  integrationType: o,
  label: i
}) => {
  const [l, p] = I("CONNECTING"), { track: E } = Er(), { icon: C, color: f, tooltip: x } = Ut(l), u = 3, m = 15, R = 2e3, [y, A] = I({}), [S, D] = I(0), [g, _] = I(R), [$, X] = I(!1), [ye, be] = I(u), {
    isInboundOAuth: Ce,
    setIsInboundOAuth: xe,
    hasTriggeredAuthorization: se,
    setHasTriggeredAuthorization: Re
  } = $t(), { baseUrl: K } = r, ce = `${K}/auth/connect/${o.toLowerCase()}/${t}`, F = `${K}/auth/status/${o.toLowerCase()}/${t}`, L = l === "CONNECTING", U = (w) => Object.keys(w).length === 0, J = () => {
    X(!1), D(0);
  };
  M(() => {
    const w = localStorage.getItem("authData");
    if (w) {
      const B = JSON.parse(w ?? "{}").access_token;
      A({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${B}`,
          ...Lt(K) && Ft(B)
        }
      });
    }
  }, [K]), M(() => {
    U(y) || X(!0);
  }, [y]);
  const le = () => {
    be(m), fetch(F, { ...y }).then((w) => w.json()).then(({ data: w }) => {
      const { status: W } = w;
      W === "CONNECTING" && p("CONNECTING"), W === "CONNECTED" && (E("settings:view:oauth:succeeded", {
        widgetId: t,
        widgetType: o
      }), p("CONNECTED"), J()), W === "NOT_CONNECTED" && (p("NOT_CONNECTED"), J());
    }).catch((w) => {
      console.warn(
        `Fetching OAuth status failed for ${o} ${t}`,
        w
      ), p("CONNECTION_FAILED");
    });
  };
  st(
    () => {
      S >= ye ? (p("CONNECTION_TIMEOUT"), J()) : (le(), D(S + 1));
    },
    $ ? g : null
  );
  const ee = () => {
    E("settings:view:oauth:started", {
      widgetId: t,
      widgetType: o
    }), fetch(ce, { ...y }).then((w) => w.json()).then(({ data: w }) => {
      const { url: W } = w, B = 620, re = 800, ue = window.innerWidth / 2 - B / 2, _e = window.innerHeight / 2 - re / 2;
      p("CONNECTING"), X(!0), window.open(
        W,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${B},
						height=${re},
						left=${ue},
						top=${_e}`
      );
    }).catch((w) => {
      console.warn(
        `Fetching OAuth connection failed for ${o} ${t}`,
        w
      ), p("CONNECTION_FAILED");
    });
  };
  return M(() => {
    Ce && !se && !U(y) && (Re(!0), xe(!1), ee());
  }, [y]), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ae, { span: 3, children: /* @__PURE__ */ a.jsx(
      H,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ a.jsxs(k, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ a.jsx(
            Z,
            {
              icon: "key",
              variant: "secondary",
              onClick: ee,
              disabled: L,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ a.jsx(dr, { content: x, children: L ? /* @__PURE__ */ a.jsx(fr, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ a.jsx(
            Fe,
            {
              "data-testid": "oauth-button-status-icon",
              name: C,
              color: f
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ a.jsx(ae, { span: 3 })
  ] });
}, yr = lr(null), Tn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yr.Provider
);
function br() {
  const r = ur(yr);
  if (r === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return r;
}
const Bt = "_settingsWrapper_eleyu_1", Gt = {
  settingsWrapper: Bt
}, Vt = Me`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, sr = [], Sn = ({
  settings: r,
  getValueByKey: t,
  handleChangeSelect: o
}) => {
  const i = "subscriptionListId", p = r?.find(
    (g) => g.key === i
  )?.label ?? "Activate re-/subscription list selection", E = t(i)?.value, { useQuery: C } = br(), [f, x] = I(sr), [u, m] = I(!!E), [R, y] = I(E), {
    data: A,
    error: S,
    loading: D
  } = C(Vt, {
    skip: !u,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return M(() => {
    E && (y(E), m(!0));
  }, [E]), M(() => {
    const g = A?.Klaviyo?.get_lists;
    if (u && g && !D && !S) {
      const _ = g?.data?.map(
        ($) => ({
          value: $?.id,
          label: $?.attributes?.name
        })
      ) || sr;
      x(_);
    }
  }, [u, A, D, S]), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ae, { span: 3, children: /* @__PURE__ */ a.jsxs(
      k,
      {
        gap: "300",
        flexDirection: "column",
        className: Gt.settingsWrapper,
        children: [
          /* @__PURE__ */ a.jsx(H, { label: p, children: /* @__PURE__ */ a.jsx(
            nt,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: u,
                onChange: () => {
                  const g = !u;
                  g || o(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), m(g);
                }
              }
            }
          ) }),
          u && S && !D && /* @__PURE__ */ a.jsx(H, { children: /* @__PURE__ */ a.jsx(jt, { error: S }) }),
          u && !S && D && /* @__PURE__ */ a.jsx(H, { children: /* @__PURE__ */ a.jsx(k, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ a.jsx(fr, {}) }) }),
          u && !S && !D && f && /* @__PURE__ */ a.jsx(H, { label: "Available lists to subscribe to", children: /* @__PURE__ */ a.jsx(
            ot,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (g) => {
                o(i, g), y(g?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (g) => g ? /* @__PURE__ */ a.jsx(ie.Paragraph, { children: g.label }) : null,
              value: R ? [
                {
                  label: (f || []).find(
                    (g) => g.value === R
                  )?.label,
                  value: R
                }
              ] : [],
              equalityFn: (g, _) => g.value === _.value,
              children: f.map((g) => /* @__PURE__ */ a.jsx(at.Item, { value: g, children: g.label }, g.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ a.jsx(ae, { span: 3 })
  ] });
}, wn = (r) => {
  if (r == null)
    return null;
  if (typeof r == "boolean" || r === "true" || r === "false") {
    const i = r === "true" || r === !0;
    return /* @__PURE__ */ a.jsx(
      Fe,
      {
        name: i ? "check-circle-filled" : "close-circle-filled",
        color: i ? G.green[500] : G.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${i ? "true" : "false"}`
      }
    );
  }
  if (typeof r == "number" || /^\d*\.?\d+$/.test(r))
    return /* @__PURE__ */ a.jsx(ke, { variant: "success", size: "small", children: r });
  if (r.startsWith("days_ago: ")) {
    const i = r.replace("days_ago: ", ""), l = i.startsWith("-"), p = i === "0", E = l ? `${i.replace("-", "")} days ago` : `in ${i} days`;
    return /* @__PURE__ */ a.jsx(ie.Paragraph, { variant: "5", color: "secondary", children: p ? "today" : E });
  }
  const o = ct(r);
  return o.isValid() ? /* @__PURE__ */ a.jsx(ie.Paragraph, { variant: "5", color: "secondary", children: o.format(kt) }) : /* @__PURE__ */ a.jsx(ke, { variant: "info", size: "small", children: r });
}, An = (r) => {
  const {
    isCreationMode: t = !1,
    componentProps: o,
    name: i,
    control: l,
    rules: p,
    defaultValue: E,
    shouldUnregister: C,
    label: f,
    helpIcon: x
  } = r, [u, m] = I(t), { field: R } = ut({
    name: i,
    control: l,
    rules: p,
    defaultValue: E,
    shouldUnregister: C
  }), y = typeof f == "string" ? f : "";
  if (!u)
    return /* @__PURE__ */ a.jsx(H, { label: f, helpIcon: x, children: /* @__PURE__ */ a.jsxs(
      Z,
      {
        "data-testid": `secret-field-button-${i}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => m(!0),
        children: [
          "Update ",
          y
        ]
      }
    ) });
  const S = {
    ...o,
    prefix: t ? o?.prefix : {
      type: "button",
      button: { icon: "close", onClick: () => {
        R.onChange(""), m(!1);
      } }
    }
  };
  return /* @__PURE__ */ a.jsx(lt, { ...r, componentProps: S });
}, Yt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Dn = ({
  integrationType: r,
  integrationId: t,
  widgetName: o,
  isCreationMode: i,
  isSubmitting: l,
  automationCouplingState: p,
  onConfirmDelete: E,
  labels: C,
  deleteConfirmationBody: f,
  confirmDeleteVariant: x = "primary"
}) => {
  const { track: u } = Er(), [m, R] = I(!1), y = { ...Yt, ...C }, A = !p || !p.isCoupled, S = () => {
    t && u("settings:view:delete:requested", {
      widgetId: t,
      widgetType: r
    }), R(!0);
  }, D = () => {
    t && u("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: r
    });
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(k, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ a.jsx(Z, { type: "submit", isLoading: l, disabled: l, children: y.submit }),
      !i && /* @__PURE__ */ a.jsx(
        dr,
        {
          content: "The widget is used in automations",
          disabled: A,
          children: /* @__PURE__ */ a.jsx(
            Z,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: S,
              disabled: !A,
              isLoading: p?.isLoading,
              children: y.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ a.jsx(
      Pt,
      {
        isOpen: m,
        setIsOpen: R,
        confirmVariant: x,
        confirmLabel: y.confirmDelete,
        cancelLabel: y.cancelDelete,
        onCancel: D,
        onConfirm: E,
        children: /* @__PURE__ */ a.jsx(k, { children: f ?? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          "Are you sure you want to delete the ",
          r,
          ' integration "',
          o,
          '"?'
        ] }) })
      }
    )
  ] });
}, Ht = Me`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Kt = Me`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Nn(r) {
  const { useQuery: t, useMutation: o } = br(), [i, l] = I(), [p, E] = I(), [C, f] = I(!1), {
    loading: x,
    data: u,
    error: m
  } = t(
    Ht,
    {
      skip: !r,
      variables: {
        conversationId: r?.toString()
      }
    }
  ), [R, { loading: y, error: A }] = o(
    Kt
  ), S = async (D, g) => await R({
    variables: {
      conversationId: (g ?? r)?.toString(),
      data: D
    }
  }).then(
    ({ data: $ }) => l($?.Storage?.storeWidgetData?.data ?? {})
  );
  return M(() => {
    !x && u && l(u?.Storage?.widgetData ?? {});
  }, [u, x]), M(() => m && E(m), [m]), M(() => f(x), [x]), M(() => A && E(A), [A]), M(() => f(y), [y]), {
    data: i,
    loading: C,
    store: S,
    error: p
  };
}
export {
  jt as DisplayErrors,
  ln as DixaApiTokenSettings,
  Wt as InboundOAuthContext,
  Pt as IntegrationModal,
  Sn as KlaviyoSubscribeSetting,
  On as OAuthSettings,
  An as PartnerHookFormSecretText,
  Tn as WidgetContextProvider,
  Dn as WidgetSettingsFormFooter,
  bn as capitalizeFirstCharacter,
  xn as countryCodes,
  _n as createMockInboundOAuthContextOptions,
  yn as deepClone,
  kt as defaultDateFormat,
  wn as displayAttributeValue,
  Ut as getConnectionStatusValues,
  Cn as getCountryNameFromCountryCode,
  Vt as getListsQuery,
  Ft as getPartnerDevApiHeaders,
  un as hasDixaHeaderCheckError,
  dn as hasDownstreamApiAuthorizationError,
  vn as hasDownstreamApiBadRequestError,
  gn as hasDownstreamApiConflictError,
  mn as hasDownstreamApiForbiddenError,
  hn as hasDownstreamApiNotFoundError,
  fn as hasDownstreamApiPermissionError,
  pn as hasDownstreamApiServiceUnavailableError,
  En as hasDownstreamApiTooManyRequestsError,
  At as hasWidgetMisconfiguredError,
  yt as isDixaHeaderCheckError,
  bt as isDownstreamApiAuthorizationError,
  Ot as isDownstreamApiBadRequestError,
  _t as isDownstreamApiConflictError,
  Tt as isDownstreamApiForbiddenError,
  Rt as isDownstreamApiNotFoundError,
  Ct as isDownstreamApiPermissionError,
  xt as isDownstreamApiServiceUnavailableError,
  St as isDownstreamApiTooManyRequestsError,
  Lt as isRunningLocalPartnerApi,
  wt as isWidgetMisconfiguredError,
  sn as makeExecuteQuery,
  an as makeUseLazyQuery,
  cn as makeUseMutation,
  on as makeUseQuery,
  Mt as parseAccessToken,
  Dt as useCopyWithDelay,
  Nn as useData,
  $t as useInboundOAuthContext,
  Er as useTracking,
  br as useWidgetContext,
  Rn as validateApiHostName
};
